import React, { useEffect, useState } from "react";
import { Download, Printer, Upload } from 'lucide-react';
import apiService from "../../../config";
import { useSignature } from '../../../DigitalSignature/UseSignatue';
import SignaturePad from '../../../DigitalSignature/SignaturePad';

const HighwayAnusuchi2 = ({ projectId = null }) => {

  const [data, setData] = useState([]);
  const [editMode, setEditMode] = useState(false); // Keep it as false to disable edit mode
  // const [editableData, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fetching, setFetching] = useState(true);
  const [error, setError] = useState(null);
  const [locationInfo, setLocationInfo] = useState({});
  const [debugInfo, setDebugInfo] = useState(null);
  const [proposalNo, setProposalNo] = useState('');
  const [proposalData, setProposalData] = useState(null);
  const [regionalInchargeName, setRegionalInchargeName] = useState("");
  const [regionalInchargeDesignation, setRegionalInchargeDesignation] = useState("");
  const [InchargeName, setInchargeName] = useState("");
  const [InchargeDesignation, setInchargeDesignation] = useState("");
  const [signatureFile, setSignatureFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const today = new Date();
  const formattedDate = `${String(today.getDate()).padStart(2, '0')}/${String(today.getMonth() + 1).padStart(2, '0')}/${today.getFullYear()}`;
  const userData = JSON.parse(localStorage.getItem('userData'));
  const userRole = parseInt(userData?.data?.user_role || userData?.user_role, 10);
  const userName = userData?.full_name || 'N/A';
  const userDesi = userData?.designation || 'N/A';
  const [uploadStatus, setUploadStatus] = useState("idle");
  // "idle" | "uploading" | "success" | "error"
  const [uploadError, setUploadError] = useState("");

  const [showSignaturePad, setShowSignaturePad] = useState(false);
  const [pdfForSigning, setPdfForSigning] = useState(null);
  const { signDocument } = useSignature();

  // Helper function to find proposalId in the project object
  const findProposalId = (projectObj) => {
    if (!projectObj) return null;

    const possibleKeys = [
      'acquisition_proposal_no',
      'land_acquisition_no',
      'proposal_id',
      'proposalId',
      'proposal',
      'id',
      'project_id'
    ];

    for (const key of possibleKeys) {
      if (projectObj[key] !== undefined && projectObj[key] !== null && projectObj[key] !== '') {
        // console.log(`Found proposalId in key: ${key}, value: ${projectObj[key]}`);
        return projectObj[key];
      }
    }

    // console.log('Available keys in project object:', Object.keys(projectObj));
    // console.log('Project object values:', projectObj);
    return null;
  };
  
  // Add this useEffect after all your useState declarations and before fetchLandHoldings
  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);

        const userData = JSON.parse(localStorage.getItem("userData"));
        const project = JSON.parse(localStorage.getItem("selectedProject"));
        const projectId = project?.id || project?.project_id;
        const proposalId = userData?.default_proposal || userData?.proposal_id;

        if (projectId && proposalId) {
          const result = await apiService.getProposalById(projectId, proposalId);
          if (result && result.status === 200) {
            const proposal = Array.isArray(result.data)
              ? result.data[0]
              : result.data;

            // ✅ Set all officer information here
            setRegionalInchargeName(
              proposal?.acquisition_regional_incharge_name || ""
            );
            setRegionalInchargeDesignation(
              proposal?.acquisition_regional_incharge_designation || ""
            );
            setInchargeName(
              proposal?.acquisition_incharge_name || ""
            );
            setInchargeDesignation(
              proposal?.acquisition_incharge_designation || ""
            );
          }
        }
      } catch (error) {
        console.error("Error loading proposal data:", error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  const fetchLandHoldings = async () => {
    setFetching(true); // show loading state before fetch
    try {
      setLoading(true);
      setError(null);

      const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
      const projectIdFromStorage = selectedProject?.id || selectedProject?.project_id;
      const proposalId = localStorage.getItem('currentProposalId') || findProposalId(selectedProject);
      const currentProjectId = projectId || projectIdFromStorage;

      // Get acquisition_regional_incharge_name from selectedProposal
      const storedProposal = JSON.parse(localStorage.getItem('selectedProposal') || '{}');
      if (storedProposal?.acquisition_regional_incharge_name) {
        setRegionalInchargeName(storedProposal.acquisition_regional_incharge_name);
      }
      if (storedProposal?.acquisition_regional_incharge_designation) {
        setRegionalInchargeDesignation(storedProposal.acquisition_regional_incharge_designation);
      }
      if (storedProposal?.acquisition_incharge_designation) {
        setInchargeDesignation(storedProposal.acquisition_incharge_designation);
      }
      if (storedProposal?.acquisition_incharge_name) {
        setInchargeName(storedProposal.acquisition_incharge_name);
      }

      if (!currentProjectId || !proposalId) {
        const missingParams = [];
        if (!currentProjectId) missingParams.push('projectId');
        if (!proposalId) missingParams.push('proposalId');

        setError(`Missing required parameters: ${missingParams.join(', ')}. Please select a project first.`);
        setLoading(false);
        return;
      }

      const storedLocationInfo = localStorage.getItem('selectedLocationInfo');
      // console.log("-------------------:",storedLocationInfo)
      let apiParams = {
        proposalId: proposalId
      };

      if (storedLocationInfo) {
        const locationData = JSON.parse(storedLocationInfo);
        apiParams = {
          ...apiParams,
          distNo: locationData.district,
          talukaNo: locationData.taluka,
          villageNo: locationData.village
        };
        setLocationInfo(locationData);
      }

      const result = await apiService.getLandHolding(currentProjectId, apiParams);

      setDebugInfo({
        apiResponse: result,
        requestParams: { projectId: currentProjectId, ...apiParams },
        responseStatus: result?.status,
        responseData: result?.data,
        dataType: typeof result?.data,
        dataLength: result?.data?.length,
        dataKeys: result?.data ? Object.keys(result.data) : null,
        rawResponse: result,
        isEmptyString: result === "",
        isNull: result === null,
        isUndefined: result === undefined
      });

      if (!result || result === "" || result === null || result === undefined) {
        setError(`API returned invalid response: ${JSON.stringify(result)}. Check API endpoint and network connection.`);
        return;
      }

      let dataArray = null;
      let responseStatus = result?.status || result?.statusCode || 200;

      if (responseStatus === 200 || responseStatus === "200") {
        // FIXED: Extract proposalData first
        if (result.proposalData && Array.isArray(result.proposalData) && result.proposalData.length > 0) {
          const proposalInfo = result.proposalData[0];
          setProposalNo(proposalInfo.acquisition_proposal_no);
          setProposalData(proposalInfo);
          // console.log('📊 Extracted Proposal No:', proposalInfo.acquisition_proposal_no);
        }

        // Then extract land holdings data
        if (Array.isArray(result.data)) {
          dataArray = result.data;
        } else if (result.data && Array.isArray(result.data.data)) {
          dataArray = result.data.data;
        } else if (result.data && Array.isArray(result.data.items)) {
          dataArray = result.data.items;
        } else if (result.data && Array.isArray(result.data.records)) {
          dataArray = result.data.records;
        } else if (result.data && Array.isArray(result.data.landHoldings)) {
          dataArray = result.data.landHoldings;
        }

        if (dataArray && dataArray.length > 0) {
          const firstRecord = dataArray[0];
          if (!storedLocationInfo && firstRecord) {
            const extractedLocationInfo = {
              projectId: firstRecord.project_id || currentProjectId,
              district: firstRecord.dist_name,
              taluka: firstRecord.tehsil_name || firstRecord.taluka_name,
              village: firstRecord.village_name || firstRecord.VillageName,
              districtNo: firstRecord.dist_no,
              talukaNo: firstRecord.tehsil_no,
              villageNo: firstRecord.village_no
            };
            setLocationInfo(extractedLocationInfo);
            localStorage.setItem('selectedLocationInfo', JSON.stringify(extractedLocationInfo));
          }

          const transformedData = dataArray.map((item, index) => ({
            ...item,
            sr_no: index + 1
          }));

          setData(transformedData);

        } else {
          const errorMsg = result.data
            ? `API returned successful response but no data records found. Response structure: ${JSON.stringify(result.data, null, 2)}`
            : 'API returned empty response';
          setError(errorMsg);
        }
      } else {
        setError(`API returned status ${responseStatus}: ${result?.message || result?.error || 'Unknown error'}. Raw response: ${JSON.stringify(result)}`);
      }
    } catch (err) {
      console.error('❌ Error fetching land holdings:', err);
      setError(`Failed to fetch land holdings data: ${err.message}`);
      setDebugInfo({
        error: err,
        errorMessage: err.message,
        errorStack: err.stack
      });
    } finally {
      setLoading(false);
    }
  };
  // to check the upload signature
  useEffect(() => {
    const initCheck = async () => {
      const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
      const projectIdFromStorage = selectedProject?.id || selectedProject?.project_id;
      const proposalId = localStorage.getItem('currentProposalId') || findProposalId(selectedProject);

      if (!projectIdFromStorage || !proposalId) return;

      try {
        const sectionRes = await apiService.getSectionFile(projectIdFromStorage, proposalId, 'anusuchi2');

        if (sectionRes?.isSignAvailable && sectionRes?.data?.length > 0) {
          const fileUrl = sectionRes.data[0].file_path;
          setPreviewUrl(fileUrl); // show PDF/image from API
          setSignatureFile(null); // no need to upload
          return; // skip the rest, since signature exists
        }
      } catch (err) {
        console.error("Error checking section file:", err);
      }

      // If no signature available, continue normal fetch flow
      fetchLandHoldings();
    };

    initCheck();
  }, [projectId]);

  // useEffect to fetch land holding list
  useEffect(() => {
    if (!previewUrl) {
      fetchLandHoldings();
    }
  }, [projectId]);

  const handleChange = (index, key, value) => {
    const updated = [...data];
    updated[index][key] = value;
    setData(updated);
  };
  // upload signature
  // upload signature
  // Modified handleUploadSignature function to work with local digital signature bridge
  const handleUploadSignature = async (file) => {
    try {
      setUploadStatus("uploading");
      setUploadError("");

      const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
      const projectIdFromStorage = selectedProject?.id || selectedProject?.project_id;
      const proposalId = localStorage.getItem('currentProposalId') || findProposalId(selectedProject);

      if (!projectIdFromStorage || !proposalId) {
        setUploadStatus("error");
        setUploadError("Missing projectId or proposalId");
        alert("Missing projectId or proposalId");
        return;
      }

      const BRIDGE_URL = "http://127.0.0.1:8000";

      // Show dialog first (always open modal)
      const signatureParams = await showDigitalSignatureDialog();
      if (!signatureParams) {
        setUploadStatus("idle");
        return; // User cancelled
      }

      // Check bridge app status AFTER modal
      try {
        const healthCheck = await fetch(`${BRIDGE_URL}/health`, { method: "GET" });
        if (!healthCheck.ok) {
          throw new Error("Bridge app not accessible");
        }
      } catch (error) {
        setUploadStatus("error");
        setUploadError("Digital signature bridge app is not running. Please start it first.");
        alert("Digital signature bridge app is not running. Please start it first.");
        return;
      }

      // Build FormData according to FastAPI API
      const formData = new FormData();
      formData.append("pdf_file", file);
      formData.append("token_name", signatureParams.tokenName);
      formData.append("pin", signatureParams.pin);
      formData.append("pages", signatureParams.pages); // ✅ string (e.g. "all" or "1-3,5")
      formData.append("position", signatureParams.position); // ✅ "Left" / "Right"
      formData.append("place_text", signatureParams.placeText || "");

      const bridgeResponse = await fetch(`${BRIDGE_URL}/sign-pdf/`, {
        method: "POST",
        body: formData,
      });

      if (!bridgeResponse.ok) {
        const errorData = await bridgeResponse.json().catch(() => ({ detail: "Unknown error" }));
        throw new Error(errorData.detail || `Bridge app error: ${bridgeResponse.status}`);
      }

      const signedPdfBlob = await bridgeResponse.blob();
      const signedPdfFile = new File([signedPdfBlob], `signed_${file.name}`, { type: "application/pdf" });

      const serverResponse = await apiService.postAddSignaturePDF(
        projectIdFromStorage,
        proposalId,
        "anusuchi2",
        signedPdfFile
      );

      if (serverResponse?.status === 200) {
        setUploadStatus("success");
        alert("PDF digitally signed and uploaded successfully!");

        const sectionRes = await apiService.getSectionFile(projectIdFromStorage, proposalId, "anusuchi2");
        if (sectionRes?.isSignAvailable && sectionRes?.data?.length > 0) {
          setPreviewUrl(sectionRes.data[0].file_path);
        }
      } else {
        setUploadStatus("error");
        setUploadError(`Failed to upload signed PDF: ${serverResponse?.message || "Unknown error"}`);
        alert(`Failed to upload signed PDF: ${serverResponse?.message || "Unknown error"}`);
      }

    } catch (error) {
      setUploadStatus("error");
      setUploadError(error.message);
      console.error("Digital signature error:", error);

      if (error.message.includes("PIN is incorrect")) {
        alert("The provided PIN is incorrect. Please try again.");
      } else if (error.message.includes("token found")) {
        alert("No PKCS#11 token found. Please connect your digital signature device.");
      } else if (error.message.includes("Bridge app not running")) {
        alert("Digital signature bridge app is not running. Please start it first.");
      } else {
        alert(`Error during digital signing: ${error.message}`);
      }
    }
  };

  // Updated dialog to match Python backend
  const showDigitalSignatureDialog = () => {
    return new Promise((resolve) => {
      const modal = document.createElement("div");
      modal.style.cssText = `
      position: fixed; top: 0; left: 0; width: 100%; height: 100%;
      background: rgba(0,0,0,0.5); display: flex; align-items: center;
      justify-content: center; z-index: 1000;
    `;

      const dialog = document.createElement("div");
      dialog.style.cssText = `
      background: white; padding: 20px; border-radius: 8px;
      max-width: 400px; width: 90%;
    `;

      dialog.innerHTML = `
      <h3 style="margin-top: 0;">Digital Signature Parameters</h3>
      <form id="signatureForm">
        <div style="margin-bottom: 15px;">
          <label style="display:block; margin-bottom:5px;">Token Name:</label>
          <select id="tokenName" required 
            style="width:100%; padding:8px; border:1px solid #ccc; border-radius:4px;">
            <option value="">Select Token</option>
            <option value="ProxKey">ProxKey</option>
            <option value="ePass2003 Auto">ePass2003 Auto</option>
            <option value="Moser Baer">Moser Baer</option>
            <option value="Safenet/Gemalto">Safenet/Gemalto</option>
          </select>
        </div>

        <div style="margin-bottom: 15px;">
          <label style="display:block; margin-bottom:5px;">PIN:</label>
          <input type="password" id="pin" required 
            style="width:100%; padding:8px; border:1px solid #ccc; border-radius:4px;">
        </div>

        <div style="margin-bottom: 15px;">
          <label style="display:block; margin-bottom:5px;">Pages (e.g., "all", "1-3,5"):</label>
          <input type="text" id="pages" value="all" required
            style="width:100%; padding:8px; border:1px solid #ccc; border-radius:4px;">
        </div>

        <div style="margin-bottom: 15px;">
          <label style="display:block; margin-bottom:5px;">Signature Position:</label>
          <select id="position" 
            style="width:100%; padding:8px; border:1px solid #ccc; border-radius:4px;">
            <option value="Right">Right</option>
            <option value="Left">Left</option>
          </select>
        </div>

        <div style="margin-bottom: 20px;">
          <label style="display:block; margin-bottom:5px;">Place Text (Optional):</label>
          <input type="text" id="placeText" placeholder="e.g., Mumbai, India"
            style="width:100%; padding:8px; border:1px solid #ccc; border-radius:4px;">
        </div>

        <div style="display:flex; gap:10px; justify-content:flex-end;">
          <button type="button" id="cancelBtn" 
            style="padding:8px 16px; border:1px solid #ccc; background:white; border-radius:4px; cursor:pointer;">
            Cancel
          </button>
          <button type="submit" 
            style="padding:8px 16px; border:none; background:#007bff; color:white; border-radius:4px; cursor:pointer;">
            Sign PDF
          </button>
        </div>
      </form>

    `;

      modal.appendChild(dialog);
      document.body.appendChild(modal);

      const form = dialog.querySelector("#signatureForm");
      const cancelBtn = dialog.querySelector("#cancelBtn");

      form.addEventListener("submit", (e) => {
        e.preventDefault();
        const params = {
          tokenName: dialog.querySelector("#tokenName").value,
          pin: dialog.querySelector("#pin").value,
          pages: dialog.querySelector("#pages").value.trim() || "all",
          position: dialog.querySelector("#position").value,
          placeText: dialog.querySelector("#placeText").value,
        };
        document.body.removeChild(modal);
        resolve(params);
      });

      cancelBtn.addEventListener("click", () => {
        document.body.removeChild(modal);
        resolve(null);
      });

      modal.addEventListener("click", (e) => {
        if (e.target === modal) {
          document.body.removeChild(modal);
          resolve(null);
        }
      });
    });
  };

  // const handleFileUpload = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setSignatureFile(file);
  //     // setPreviewUrl(URL.createObjectURL(file));
  //     handleUploadSignature(file);
  //   }
  // };

  const handleUploadedFile = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    // ✅ open uploaded file in signature modal
    setPdfForSigning(file);
    setShowSignaturePad(true);
  };


  const handleViewFile = () => {
    if (previewUrl) {
      window.open(previewUrl, "_blank");
    }
  }
  const handlePrint = () => {
    if (previewUrl) {
      // 🔹 Open signed PDF in new tab
      window.open(previewUrl, "_blank", "noopener,noreferrer");
      return;
    }

    // ⏬ Fallback: Print HTML if previewUrl not available
    if (!data || data.length === 0) {
      alert("No data to print yet.");
      return;
    }

    const wasEditing = editMode;
    setEditMode(false);

    setTimeout(() => {
      const printContent = document.getElementById("notice-content")?.innerHTML;

      if (!printContent || printContent.trim() === "") {
        alert("Print content is empty.");
        setEditMode(wasEditing);
        return;
      }

      const win = window.open("", "", "height=900,width=1200");
      win.document.write(`<html><head><title>परिशिष्ट 2</title>`);
      win.document.write(`<style>
        @page {
          size: A4 portrait;   /* Orientation */
          margin-top: 0.19in;
          margin-bottom: 0.25in;
          margin-left: 0.81in;
          margin-right: 0.5in;
        }
        body {
          font-family: 'DVOT-Surekh', 'Mangal', 'Arial', sans-serif;
        }
      table { border-collapse: collapse; width: 100%; margin-top: 10px; }
      th, td { border: 1px solid black; padding: 4px; text-align: center; }
      h2, h3 { text-align: center; margin: 0; }
      .center-text { text-align: center; }
      .left-text { text-align: left; }
    </style></head><body>`);
      win.document.write(printContent);
      win.document.write("</body></html>");
      win.document.close();
      win.print();

      setEditMode(wasEditing);
    }, 200);
  };

  const handleDownloadWord = () => {
    if (previewUrl) {
      // 🔹 Open same file in new tab but force .doc download
      const link = document.createElement("a");
      link.href = previewUrl;
      link.target = "_blank";
      link.download = "परिशिष्ट 2.doc";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return;
    }

    // ⏬ Fallback: Generate Word from HTML if no previewUrl
    if (loading) {
      alert("Data is still loading. Please wait before downloading.");
      return;
    }

    const wasEditing = editMode;
    setEditMode(false);

    setTimeout(() => {
      const content = document.getElementById("notice-content").innerHTML;

      const header = `
      <html xmlns:o='urn:schemas-microsoft-com:office:office' 
            xmlns:w='urn:schemas-microsoft-com:office:word' 
            xmlns='http://www.w3.org/TR/REC-html40'>
      <head><title>अनुसूची-२</title>
      <style>
        body { font-family: 'Mangal', 'Arial', sans-serif; margin: 20mm; }
        table { border-collapse: collapse; width: 100%; margin-top: 10px; }
        th, td { border: 1px solid black; padding: 4px; text-align: center; }
        h2, h3 { text-align: center; margin: 0; }
        .center-text { text-align: center; }
        .left-text { text-align: left; }
      </style>
      </head><body>`;

      const footer = "</body></html>";
      const sourceHTML = header + content + footer;

      const blob = new Blob(['\ufeff', sourceHTML], {
        type: 'application/msword',
      });

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `परिशिष्ट 2.doc`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      setEditMode(wasEditing);
    }, 200);
  };

  // if (!isOpen) return null;

  const surveyTypes = ["सर्व्हे क्रमांक", "गट क्रमांक", "प्लॉट क्रमांक"];

  const surveyKramankData = data.filter(
    item => surveyTypes.includes(item.survey_type)
  );


  const gharKramankData = data.filter(
    item => item.survey_type === "घर क्रमांक."
  );

  return (
    <div className="max-w-6xl mx-auto p-6 bg-white">
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center space-x-3">
          <button
            onClick={handlePrint}
            className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            <Printer size={18} />
            <span>Print</span>
          </button>
          <button
            onClick={handleDownloadWord}
            className="flex items-center space-x-2 px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 disabled:opacity-50"
          >
            <Download size={18} />
            <span>Download Word</span>
          </button>

          {/* Upload Signature */}
          {/* Conditional Rendering */}
          {/* {!previewUrl ? ( */}

          <button className="relative">
            <label className="flex items-center space-x-2 px-4 py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700 cursor-pointer">
              <Upload size={18} />
              <span>Upload Signature</span>
              <input
                type="file"
                accept="application/pdf,image/*"
                className="hidden"
                onChange={handleUploadedFile}
              />
            </label>
          </button>
          {/* ) : (
              // Show View button if file uploaded
              <button
                onClick={handleViewFile}
                className="flex items-center space-x-2 px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700"
              >
                View File
              </button>
            )} */}
        </div>
      </div>
      {previewUrl ? (
        // 🔹 Show PDF directly if signed file exists
        <div className="w-full bg-white p-4 rounded-lg">
          <iframe
            src={`${previewUrl}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
            // src={`${previewUrl}`}
            title="Anusuchi-2 PDF"
            width="100%"
            height="800px"
            style={{
              border: "none",
              borderRadius: "8px",
              boxShadow: "none",
              outline: "none",
              margin: "0",
              padding: "0"
            }}
            frameBorder="0"
            seamless
          />
        </div>
      ) : (
        <>


          {/* Header */}
          <div className="text-center mb-6">
            <div id="notice-content" style={{ margin: "10mm" }}>
              {loading ? (
                <div className="flex justify-center items-center h-96">
                  <p className="text-lg text-gray-600">Loading...</p>
                </div>
              ) : (
                <>
                  <h3 className="center-text font-semibold">परिशिष्ट 2</h3>
                  {/* <p className="center-text" style={{ fontWeight: "bold" }}>
                    प्रस्तावामध्ये समाविष्ट खाजगी जमिनींचा तपशील
                  </p> */}
                  <h3 className="center-text" style={{ fontWeight: "bold" }}>
                    प्रकल्प नाव: {data.projectName || proposalData?.project_name} | प्रस्ताव नाव: {proposalNo}
                  </h3>
                  {data.length > 0 && (
                    <p className="center-text" style={{ fontWeight: "bold" }}>
                      मौजे : {data[0].village_name} , तालुका : {data[0].taluka_name} , जिल्हा : {data[0].dist_name}
                    </p>
                  )}

                  {surveyKramankData.length > 0 &&
                    <table style={{ borderCollapse: "collapse", width: "100%", border: "1px solid black" }}>
                      <thead>
                        <tr>
                          <th style={{ border: "1px solid black", padding: "8px" }}>अ.क्र.</th>
                          <th style={{ border: "1px solid black", padding: "8px", minWidth: "200px" }}>भूधारकाचे नाव</th>
                          <th style={{ border: "1px solid black", padding: "8px" }}>गट/सर्व्हे</th>
                          <th style={{ border: "1px solid black", padding: "8px" }}>भूधारणा पद्धती</th>
                          <th style={{ border: "1px solid black", padding: "8px" }}>७/१२ प्रमाणे एकुण क्षेत्र
                          </th>
                          {/* <th style={{ border: "1px solid black", padding: "8px" }}>
                          संपादन करावयाचे क्षेत्र
                          (हे. आर)
                        </th> */}
                          <th style={{ border: "1px solid black", padding: "8px" }}>
                            संपादनाचे प्रस्तावित क्षेत्र (हे. आर)
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {[...surveyKramankData]
                          .sort((a, b) => a.LandAcquisition_id - b.LandAcquisition_id)
                          .map((item, idx) => {
                            const hasOwners = item.owners && item.owners.length > 0;
                            const rowSpanValue = hasOwners ? item.owners.length : 1;

                            return hasOwners ? (
                              <React.Fragment key={idx}>
                                {item.owners.map((owner, ownerIdx) => (
                                  <tr key={`${idx}-owner-${ownerIdx}`}>
                                    {/* Sr No — only in first owner row */}
                                    {ownerIdx === 0 && (
                                      <td
                                        rowSpan={rowSpanValue}
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          verticalAlign: "center ",
                                          textAlign: "center"
                                        }}
                                      >
                                        {idx + 1}
                                      </td>
                                    )}

                                    {/* Owner Name */}
                                    <td
                                      style={{
                                        border: "1px solid black",
                                        padding: "8px",
                                        textAlign: "left",
                                        whiteSpace: "pre-line"
                                      }}
                                    >
                                      {owner.owner_name
                                        ?.split(",")
                                        .map((name, i, arr) =>
                                          i < arr.length - 1 ? name.trim() + "," : name.trim()
                                        )
                                        .join("\n")}
                                    </td>

                                    {/* Survey No — only in first owner row */}
                                    {ownerIdx === 0 && (
                                      <td
                                        rowSpan={rowSpanValue}
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          verticalAlign: "center",
                                          textAlign: "center"
                                        }}
                                      >
                                        {item.survey_no}
                                      </td>
                                    )}

                                    {/* Land Holding Type — only in first owner row */}
                                    {ownerIdx === 0 && (
                                      <td
                                        rowSpan={rowSpanValue}
                                        style={{
                                          paddingBottom: "20px",
                                          border: "1px solid black",
                                          padding: "8px",
                                          verticalAlign: "center",
                                          textAlign: "center"
                                        }}
                                      >
                                        {item.land_holding_type || "-"}
                                      </td>
                                    )}

                                    {/* Total Area — only in first owner row */}
                                    {/* {ownerIdx === 0 && (
                                    <td
                                      rowSpan={rowSpanValue}
                                      style={{
                                        border: "1px solid black",
                                        padding: "8px",
                                        verticalAlign: "center",
                                        textAlign: "center"
                                      }}
                                    >
                                      {parseFloat(item.total_area || 0).toFixed(2)}
                                    </td>
                                  )} */}

                                    {/* Owner Total Area */}
                                    <td
                                      style={{
                                        border: "1px solid black",
                                        padding: "8px",
                                        textAlign: "center",
                                        verticalAlign: "center"
                                      }}
                                    >
                                      {parseFloat(owner.owner_total_area || 0).toFixed(2)}
                                    </td>

                                    {/* Owner Aqr Area */}
                                    <td
                                      style={{
                                        border: "1px solid black",
                                        padding: "8px",
                                        textAlign: "center",
                                        verticalAlign: "center"
                                      }}
                                    >
                                      {parseFloat(owner.owner_aqr_area || 0).toFixed(2)}
                                    </td>
                                  </tr>
                                ))}
                              </React.Fragment>
                            ) : null;
                          })}

                        {/* Total Row */}
                        <tr>
                          <td
                            colSpan={4}
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                              fontWeight: "bold",
                              textAlign: "right"
                            }}
                          >
                            एकुण
                          </td>
                          <td
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                              fontWeight: "bold",
                              textAlign: "center"
                            }}
                          >
                            {data.reduce(
                              (sum, item) =>
                                sum +
                                (item.owners?.reduce(
                                  (ownerSum, o) => ownerSum + Number(o.owner_total_area || 0),
                                  0
                                ) || 0),
                              0
                            ).toFixed(2)}
                          </td>
                          <td
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                              fontWeight: "bold",
                              textAlign: "center"
                            }}
                          >
                            {data.reduce(
                              (sum, item) =>
                                sum +
                                (item.owners?.reduce(
                                  (ownerSum, o) => ownerSum + Number(o.owner_aqr_area || 0),
                                  0
                                ) || 0),
                              0
                            ).toFixed(2)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  }

                  {gharKramankData.length > 0 &&
                    <table className="mt-8" style={{ borderCollapse: "collapse", width: "100%", border: "1px solid black" }}>
                      <thead>
                        <tr>
                          <th style={{ border: "1px solid black", padding: "8px" }}>अ.क्र.</th>
                          <th style={{ border: "1px solid black", padding: "8px", minWidth: "200px" }}>घर मालकाचे नाव</th>
                          <th style={{ border: "1px solid black", padding: "8px" }}>घर क्रमांक</th>
                          <th style={{ border: "1px solid black", padding: "8px" }}>भूधारणा पद्धती</th>
                          <th style={{ border: "1px solid black", padding: "8px" }}>७/१२ प्रमाणे एकुण क्षेत्र
                          </th>
                          {/* <th style={{ border: "1px solid black", padding: "8px" }}>
                          संपादन करावयाचे क्षेत्र
                          (हे. आर)
                        </th> */}
                          <th style={{ border: "1px solid black", padding: "8px" }}>
                            संपादनाचे प्रस्तावित क्षेत्र (चौरस फूट)
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {[...gharKramankData]
                          .sort((a, b) => a.LandAcquisition_id - b.LandAcquisition_id)
                          .map((item, idx) => {
                            const hasOwners = item.owners && item.owners.length > 0;
                            const rowSpanValue = hasOwners ? item.owners.length : 1;

                            return hasOwners ? (
                              <React.Fragment key={idx}>
                                {item.owners.map((owner, ownerIdx) => (
                                  <tr key={`${idx}-owner-${ownerIdx}`}>
                                    {/* Sr No — only in first owner row */}
                                    {ownerIdx === 0 && (
                                      <td
                                        rowSpan={rowSpanValue}
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          verticalAlign: "center ",
                                          textAlign: "center"
                                        }}
                                      >
                                        {idx + 1}
                                      </td>
                                    )}

                                    {/* Owner Name */}
                                    <td
                                      style={{
                                        border: "1px solid black",
                                        padding: "8px",
                                        textAlign: "left",
                                        whiteSpace: "pre-line"
                                      }}
                                    >
                                      {owner.owner_name
                                        ?.split(",")
                                        .map((name, i, arr) =>
                                          i < arr.length - 1 ? name.trim() + "," : name.trim()
                                        )
                                        .join("\n")}
                                    </td>

                                    {/* Survey No — only in first owner row */}
                                    {ownerIdx === 0 && (
                                      <td
                                        rowSpan={rowSpanValue}
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          verticalAlign: "center",
                                          textAlign: "center"
                                        }}
                                      >
                                        {item.survey_no}
                                      </td>
                                    )}

                                    {/* Land Holding Type — only in first owner row */}
                                    {ownerIdx === 0 && (
                                      <td
                                        rowSpan={rowSpanValue}
                                        style={{
                                          paddingBottom: "20px",
                                          border: "1px solid black",
                                          padding: "8px",
                                          verticalAlign: "center",
                                          textAlign: "center"
                                        }}
                                      >
                                        {item.land_holding_type || "-"}
                                      </td>
                                    )}

                                    {/* Total Area — only in first owner row */}
                                    {/* {ownerIdx === 0 && (
                                    <td
                                      rowSpan={rowSpanValue}
                                      style={{
                                        border: "1px solid black",
                                        padding: "8px",
                                        verticalAlign: "center",
                                        textAlign: "center"
                                      }}
                                    >
                                      {parseFloat(item.total_area || 0).toFixed(2)}
                                    </td>
                                  )} */}

                                    {/* Owner Total Area */}
                                    <td
                                      style={{
                                        border: "1px solid black",
                                        padding: "8px",
                                        textAlign: "center",
                                        verticalAlign: "center"
                                      }}
                                    >
                                      {parseFloat(owner.owner_total_area || 0).toFixed(2)}
                                    </td>

                                    {/* Owner Aqr Area */}
                                    <td
                                      style={{
                                        border: "1px solid black",
                                        padding: "8px",
                                        textAlign: "center",
                                        verticalAlign: "center"
                                      }}
                                    >
                                      {parseFloat(owner.owner_aqr_area || 0).toFixed(2)}
                                    </td>
                                  </tr>
                                ))}
                              </React.Fragment>
                            ) : null;
                          })}

                        {/* Total Row */}
                        <tr>
                          <td
                            colSpan={4}
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                              fontWeight: "bold",
                              textAlign: "right"
                            }}
                          >
                            एकुण
                          </td>
                          <td
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                              fontWeight: "bold",
                              textAlign: "center"
                            }}
                          >
                            {data.reduce(
                              (sum, item) =>
                                sum +
                                (item.owners?.reduce(
                                  (ownerSum, o) => ownerSum + Number(o.owner_total_area || 0),
                                  0
                                ) || 0),
                              0
                            ).toFixed(2)}
                          </td>
                          <td
                            style={{
                              border: "1px solid black",
                              padding: "8px",
                              fontWeight: "bold",
                              textAlign: "center"
                            }}
                          >
                            {data.reduce(
                              (sum, item) =>
                                sum +
                                (item.owners?.reduce(
                                  (ownerSum, o) => ownerSum + Number(o.owner_aqr_area || 0),
                                  0
                                ) || 0),
                              0
                            ).toFixed(2)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  }

                  <p
                    style={{
                      textAlign: "center",
                      marginTop: "20px",
                      fontSize: "small",
                    }}
                  ></p>

                  <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
                    {/* Left side */}
                    <div style={{ textAlign: "left" }}>
                      <p>दिनांक: {formattedDate}</p>
                      <p>ठिकाण:{proposalData?.acquisition_incharge_address || "N/A"}</p>
                    </div>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
                    {/* Right side */}

                    <div style={{ textAlign: "center", marginTop: "150px", lineHeight: "1.5" }}>
                      <p> {regionalInchargeName ? ` (${regionalInchargeName})` : ""}</p>
                      <p> {regionalInchargeDesignation ? ` ${regionalInchargeDesignation}` : ""}</p>
                    </div>
                    <div style={{ textAlign: "center", lineHeight: "1.5", marginTop: "150px" }}>
                      <p> {InchargeName ? ` (${InchargeName})` : ""}</p>
                      <p> {InchargeDesignation ? ` ${InchargeDesignation}` : ""}</p>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}

      {showSignaturePad && pdfForSigning && (
        <SignaturePad
          pdfFile={pdfForSigning}
          onSign={(signaturesArray) => {
            setShowSignaturePad(false);

            signDocument(pdfForSigning, signaturesArray).then(async (signedPdf) => {
              const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");
              const projectId = selectedProject?.id || selectedProject?.project_id;
              const proposalId = localStorage.getItem("currentProposalId");

              await apiService.postAddSignaturePDF(
                projectId,
                proposalId,
                "parishisht1",
                signedPdf
              );

              const sectionRes = await apiService.getSectionFile(
                projectId,
                proposalId,
                "parishisht1"
              );

              if (sectionRes?.isSignAvailable) {
                setPreviewUrl(sectionRes.data[0].file_path);
              }

              setPdfForSigning(null);
            });
          }}
          onCancel={() => {
            setShowSignaturePad(false);
            setPdfForSigning(null);
          }}
        />
      )}

    </div>
  );
};

export default HighwayAnusuchi2;